import React, { useCallback, useEffect, useRef, useState } from "react";
import {
  Accordion,
  AccordionSummary,
  Button,
  Chip,
  IconButton,
  Typography,
} from "@material-ui/core";
import AddIcon from "@material-ui/icons/Add";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import Dashbard from "../../Dashbard";
import Loader from "../../../../../components/common/Loader";
import GridSearchFilter, {
  AutoComplete,
  FilterAutoComplete,
  SelectedChiptItems,
  SelectedDateChip,
} from "../../../../../components/common/FilterLayout/GridFilter";
import LeadGenerationGrid from "./LeadGenerationGrid";
import { useDebounce } from "../../../../../utils/use-debounce";
import { InputField, Pagination } from "../../../../../components/common";
import { useDispatch, useSelector } from "react-redux";
import { contactsTypesActions } from "../../../../../store/contactTypes/contactTypesActions";
import { DayTableModel } from "@fullcalendar/core/internal";
import { CommentSharp, ExpandMore, MoreHoriz } from "@material-ui/icons";
import { ChipItem } from "../../Conversations/ConverstionSettings/GridFilter";
import { values } from "lodash";
import { FilterCreationDate } from "../../EndUser";
import moment from "moment";
import {
  ConversationConfig,
  endpoints,
} from "../../../../../config/conversationConfig";
import * as signalR from "@microsoft/signalr";
import { conversationAction } from "../../../../../store/conversations/conversationAction";
import { contactsActions } from "../../../../../store/contacts/contactsActions";

const LeadGeneration = () => {
  const { hubId } = useSelector(state => state.conversationReducer);
  const { timeZone } = Intl.DateTimeFormat().resolvedOptions();
  const history = useHistory();
  const dispatch = useDispatch();
  let filtersIndex = 0;
  const filtersLimit = 4;
  const indexReference = useRef(filtersIndex);
  const selectedRoomRef = useRef(null);
  const { connectionUrl } = endpoints.conversation;
  const [connection, setConnection] = useState(null);
  const [roomMsgs, setRoomMsgs] = useState([]);
  const [selectedRoom, setSelectedRoom] = useState(null);
  const [leadData, setLeadData] = useState(null);

  const [isLoading, setLoading] = useState(false);
  const [filters, setFilters] = useState({
    name: "",
    firstName: "",
    lastName: "",
    email: [],
    platform: [],
    isConnected: null,
    DateFrom: null,
    DateTo: null,
  });
  const [emailValue, setEmailValue] = useState("");
  const { debouncedValue } = useDebounce(filters.name, 500);
  const [page, setPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [order, setOrder] = useState({
    orderByKey: "Id",
    orderVal: 0,
  });
  const [paginationResponse, setPaginationResponse] = useState({
    currentCount: 0,
    totalRecords: 0,
  });
  const [showFilters, setShowFilter] = useState(false);
  const [isFilter, setIsFilter] = useState(false);
  const [showFilterCounter, setShowFilterCounter] = useState(0);
  const [LeadsData, setLeadsData] = useState([]);

  const platformOptions = [
    {
      id: 0,
      value: "Facebook",
    },
    {
      id: 1,
      value: "Instagram",
    },
    {
      id: 2,
      value: "Shopify",
    },
    {
      id: 3,
      value: "Accounts",
    },
    {
      id: 4,
      value: "IOS",
    },
    {
      id: 5,
      value: "Android",
    },
  ];

  const connectionOptions = [
    {
      id: 0,
      name: "No",
    },
    {
      id: 1,
      name: "Yes",
    },
  ];

  const filtersCount =
    (filters.firstName ? 1 : 0) +
    (filters.lastName ? 1 : 0) +
    (filters.email?.length ? filters.email?.length : 0) +
    (filters.platform?.length ? filters.platform?.length : 0) +
    (filters.isConnected !== null ? 1 : 0) +
    (filters.DateFrom ? 1 : 0) +
    (filters.DateTo ? 1 : 0);

  const onOrderBy = newOrder => {
    setOrder(newOrder);
  };

  const loadLeadsGeneration = useCallback(() => {
    setLoading(true);
    dispatch(
      contactsTypesActions.onGetLeadsPaginatedData({
        pagination: {
          pageSize: rowsPerPage,
          pageNo: page,
          orderByKey: order.orderByKey,
          orderByVal: order.orderVal,
        },
        firstName: filters.firstName,
        lastName: filters.lastName,
        email: filters.email,
        contactNo: "",
        platform:
          platformOptions
            .filter(option => filters.platform.includes(option.id))
            .map(option => option.value) || [],
        DateFrom: filters.DateFrom
          ? moment(filters.DateFrom).format("MM/DD/yyyy")
          : null,
        DateTo: filters.DateTo
          ? moment(filters.DateTo).format("MM/DD/yyyy")
          : null,
        search: debouncedValue,
        isConnected:
          filters.isConnected === "No"
            ? false
            : filters.isConnected === "Yes"
            ? true
            : null,
      })
    ).then(data => {
      if (data?.data?.success) {
        setLeadsData(data?.data?.data?.data);
        setPaginationResponse(data?.data?.data?.pagination);
      } else {
        setLeadsData([]);
        setPaginationResponse({
          currentCount: 0,
          totalRecords: 0,
        });
      }
      setLoading(false);
    });
  }, [
    dispatch,
    debouncedValue,
    page,
    rowsPerPage,
    order.orderByKey,
    order.orderVal,
  ]);

  useEffect(() => {
    loadLeadsGeneration();
  }, [debouncedValue, page, rowsPerPage, order]);

  const showFilter = () => {
    window.scroll(0, 0);
    // document.body.classList.add("bodyScroll");
    setIsFilter(true);
  };

  const hideFilter = () => {
    setIsFilter(false);
  };

  const applyFilters = () => {
    setShowFilterCounter(filtersCount);
    hideFilter();
    if (page === 1) {
      setLoading(true);
      dispatch(
        contactsTypesActions.onGetLeadsPaginatedData({
          pagination: {
            pageSize: rowsPerPage,
            pageNo: page,
            orderByKey: order.key,
            orderByVal: order.val,
          },
          firstName: filters.firstName,
          lastName: filters.lastName,
          email: filters.email,
          contactNo: "",
          platform:
            platformOptions
              .filter(option => filters.platform.includes(option.id))
              .map(option => option.value) || [],
          isConnected:
            filters.isConnected === "No"
              ? false
              : filters.isConnected === "Yes"
              ? true
              : null,
          DateFrom: filters.DateFrom
            ? moment(filters.DateFrom).format("MM/DD/yyyy")
            : null,
          DateTo: filters.DateTo
            ? moment(filters.DateTo).format("MM/DD/yyyy")
            : null,
          search: debouncedValue,
        })
      ).then(data => {
        if (data?.data?.success) {
          setLeadsData(data?.data?.data?.data);
          setPaginationResponse(data?.data?.data?.pagination);
        } else {
          setLeadsData([]);
          setPaginationResponse({
            currentCount: 0,
            totalRecords: 0,
          });
        }
        setLoading(false);
      });
    }
  };

  const onClearButtonPress = () => {
    setLoading(true);
    setPage(1);
    setRowsPerPage(10);
    setShowFilterCounter(0);
    setFilters({
      name: "",
      firstName: "",
      lastName: "",
      email: [],
      platform: [],
      isConnected: null,
      DateFrom: null,
      DateTo: null,
    });
    dispatch(
      contactsTypesActions.onGetLeadsPaginatedData({
        pagination: {
          pageSize: 10,
          pageNo: 1,
          orderByKey: "Id",
          orderByVal: 0,
        },
        firstName: "",
        lastName: "",
        email: [],
        contactNo: "",
        platform: [],
        isConnected: null,
        search: "",
        DateFrom: null,
        DateTo: null,
      })
    ).then(data => {
      if (data?.data?.success) {
        setLeadsData(data?.data?.data?.data);
        setPaginationResponse(data?.data?.data?.pagination);
      } else {
        setLeadsData([]);
        setPaginationResponse({
          currentCount: 0,
          totalRecords: 0,
        });
      }
      setLoading(false);
    });
  };

  // const buildConnection = useCallback(() => {
  //   console.log("Building Connection");
  //   const protocol = new signalR.JsonHubProtocol();
  //   // const transport = signalR.HttpTransportType.WebSockets;
  //   const connectURL = `${connectionUrl}?ClientId=${ConversationConfig.clientId}&ProductId=${ConversationConfig.productId}&ClientName=${ConversationConfig.userName}&generic=${ConversationConfig.generic}`;
  //   const connect = new signalR.HubConnectionBuilder()
  //     .withUrl(connectURL, {
  //       logMessageContent: true,
  //       logger: signalR.LogLevel.Trace,
  //       // transport: transport,
  //       // skipNegotiation: true,
  //     })
  //     .withAutomaticReconnect()
  //     .withHubProtocol(protocol)
  //     .build();
  //   setConnection(connect);
  //   connect.on("send", data => {});
  //   connect
  //     .start()
  //     .then(() => {})
  //     .catch(err => {
  //       console.log("error while establishing signalr connection: " + err);
  //     });
  // }, [connectionUrl]);

  // useEffect(() => {
  //   buildConnection();
  // }, [buildConnection]);

  // useEffect(() => {
  //   if (!!connection) {
  //     connection.on("onUserConnected", data => {
  //       console.log("hubId : ", data);
  //       if (data)
  //         dispatch(conversationAction.onChange("hubId", data?.hubUserId));
  //     });
  //     connection.on("messageRecieved", data => {
  //       loadRoomChat(selectedRoomRef?.current);
  //     });
  //   }
  // }, [connection, dispatch]);

  const loadRoomChat = useCallback(
    chatDetail => {
      setLoading(true);
      dispatch(
        conversationAction.onGetChatDetailsByRoomId({
          roomId: chatDetail?.roomId,
          productId: ConversationConfig.productId,
          hubUserId: chatDetail?.hubUserId,
          take: 10000,
          skip: 0,
        })
      ).then(res => {
        setLoading(false);
        if (res?.responseCode === 1) {
          setRoomMsgs(res.responseData);
        }
      });
    },
    [dispatch]
  );

  useEffect(() => {
    if (!!selectedRoom) loadRoomChat(selectedRoom);
  }, [loadRoomChat, selectedRoom?.roomId]);

  const headers = [
    { label: "Index", key: "id" },
    { label: "First Name", key: "firstName" },
    { label: "Last Name", key: "lastName" },
    { label: "Email", key: "email" },
    { label: "Created On", key: "createdOn" },
    { label: "Platform", key: "platform" },
    { label: "Contacted through E-Mail", key: "isConnected" },
  ];

  const downloadCSV = jsonArray => {
    if (!Array.isArray(jsonArray) || jsonArray.length === 0) {
      console.error("Invalid or empty JSON array");
      return;
    }

    const csvRows = [headers.map(x => x.label).join(",")];

    for (const item of jsonArray) {
      const values = headers.map(header => {
        const escapedValue = String(item[header.key] ?? "N/A").replace(
          /"/g,
          '""'
        );
        return `"${escapedValue}"`;
      });
      csvRows.push(values.join(","));
    }

    const csvString = csvRows.join("\n");

    const bom = "\uFEFF";
    const csvWithBom = bom + csvString;

    const blob = new Blob([csvWithBom], { type: "text/csv;charset=utf-8;" });
    const url = URL.createObjectURL(blob);

    const a = document.createElement("a");
    a.href = url;
    a.download = `leads-${new Date().getMilliseconds()}`;
    document.body.appendChild(a);
    a.click();

    document.body.removeChild(a);
    URL.revokeObjectURL(url);
  };

  const handleExport = () => {
    setLoading(true);
    dispatch(
      contactsTypesActions.onGetLeadsPaginatedData({
        pagination: {
          pageSize: paginationResponse.totalRecords,
          pageNo: 1,
          orderByKey: order.orderByKey,
          orderByVal: order.orderVal,
        },
        firstName: filters.firstName,
        lastName: filters.lastName,
        email: filters.email,
        contactNo: "",
        platform:
          platformOptions
            .filter(option => filters.platform.includes(option.id))
            .map(option => option.value) || [],
        DateFrom: filters.DateFrom
          ? moment(filters.DateFrom).format("MM/DD/yyyy")
          : null,
        DateTo: filters.DateTo
          ? moment(filters.DateTo).format("MM/DD/yyyy")
          : null,
        search: debouncedValue,
        isConnected:
          filters.isConnected === "No"
            ? false
            : filters.isConnected === "Yes"
            ? true
            : null,
      })
    ).then(data => {
      if (data?.data && data?.data.success) {
        const dataForExport = data?.data?.data?.data.map((item, index) => ({
          id: index + 1,
          firstName: item.firstName,
          lastName: item.lastName,
          email: item.email,
          createdOn: item.createdOn
            ? moment(item.createdOn).format("DD-MM-YYYY")
            : "",
          platform: item.platform,
          isConnected: item.isConnected ? "Yes" : "No",
        }));
        downloadCSV(dataForExport);
      }
      setLoading(false);
    });
  };

  const onSendMessage = async ({
    messageContent,
    clearContent,
    fileName,
    uploadFile,
  }) => {
    // setLoading(true);
    // let removedEntities = messageContent?.replace(/&nbsp;/g, " ");
    // let withoutTags = removedEntities?.replace(/<[^>]*>/g, "");
    // let cleanedStr = withoutTags?.replace(/\s+/g, "").trim();
    // if (!messageContent?.trim() && !Boolean(fileName)) {
    //   setLoading(false);
    //   return;
    // }
    // let attachments = [];
    // if (fileName && fileName !== "") {
    //   const savedAttachments = await dispatch(
    //     conversationAction.onUploadFile(uploadFile)
    //   );
    //   if (savedAttachments?.responseCode === 1) {
    //     attachments.push({
    //       name: fileName,
    //       url: savedAttachments.responseData?.url,
    //     });
    //   }
    // }
    //  if(selectedRoom){
    //   const data = {
    //     roomId: selectedRoom?.roomId,
    //     hubUserId: hubId,
    //     content: Boolean(cleanedStr) ? messageContent : "",
    //     tTimeZone: timeZone,
    //     attachments: attachments.length
    //       ? [{ name: fileName, path: attachments[0].url }]
    //       : [],
    //   };
    //   if (leadData?.platform === "Facebook") {
    //     let removeBRTag = messageContent?.replace(/<br\s*\/?>/gi, "\n");
    //     let removedEntities = removeBRTag?.replace(/&nbsp;/g, " ");
    //     let content = removedEntities?.replace(/<[^>]*>/g, "").trim();
    //     dispatch(
    //       conversationAction.onSendMessages({
    //         messageFrom: "Aquatic AV",
    //         messageTo: leadData?.roomName,
    //         message: content ?? "",
    //         attachments: attachments.length
    //           ? [{ name: fileName, path: attachments[0].url }]
    //           : [],
    //       })
    //     ).then(res => {
    //       setLoading(false);
    //       if (res?.responseMsg === "Success") {
    //         loadRoomChat(selectedRoom);
    //         clearContent();
    //       }
    //     });
    //   }
    //   if (leadData?.platform === "Instagram") {
    //     let removeBRTag = messageContent?.replace(/<br\s*\/?>/gi, "\n");
    //     let removedEntities = removeBRTag?.replace(/&nbsp;/g, " ");
    //     let content = removedEntities?.replace(/<[^>]*>/g, "").trim();
    //     dispatch(
    //       conversationAction.onSendInstaMessages({
    //         messageFrom: "Aquatic AV",
    //         messageTo: leadData?.roomName,
    //         message: content ?? "",
    //         attachments: attachments.length
    //           ? [{ name: fileName, path: attachments[0].url }]
    //           : [],
    //       })
    //     ).then(res => {
    //       setLoading(false);
    //       if (res?.responseMsg === "Success") {
    //         loadRoomChat(selectedRoom);
    //         clearContent();
    //       }
    //     });
    //   } else {
    //     connection.send("SendMessage", data).then(x => {
    //       setLoading(false);
    //       loadRoomChat(selectedRoom);
    //       clearContent();
    //     });
    //   }
    //   dispatch(conversationAction.onChange("loadCurrentListing", true));
    // }
  };

  return (
    <Dashbard>
      <div className='body-content'>
        {isLoading ? <Loader /> : null}
        <div className='contentHeading launchBtn'>
          <h1>All Leads</h1>
          {/* <Button
                        color='primary'
                        variant='contained'
                        startIcon={<AddIcon />}
                        onClick={() => history.push("/new-lead-generation")}
                        >
                        New Lead Generation
                     </Button> */}
        </div>
        <div className='gridBody contentBody '>
          <GridSearchFilter
            isFilterAdded={true}
            setFilters={setFilters}
            filters={filters}
            setPage={setPage}
            setRowsPerPage={setRowsPerPage}
            title={"All Leads Filter"}
            isFilter={isFilter}
            showFilter={showFilter}
            hideFilter={hideFilter}
            applyFilters={applyFilters}
            showFilterCounter={showFilterCounter}>
            <Accordion
              defaultExpanded
              id='end-user-filter-expandable'
              TransitionProps={{ unmountOnExit: true }}>
              <AccordionSummary expandIcon={<ExpandMore />}>
                <Typography>
                  <span>Active Filter(s)</span>
                  <span>
                    <Button
                      className='filterClearBtn filterClearBtnStyle'
                      variant='outlined'
                      onClick={() => {
                        hideFilter();
                        onClearButtonPress();
                      }}>
                      Clear
                    </Button>
                  </span>
                </Typography>
              </AccordionSummary>
              <div style={{ marginBottom: "10px" }}>
                {filtersCount <= 0 && (
                  <div className={`filtersChips`}>No Active Filter(s)</div>
                )}
              </div>

              <SelectedDateChip
                startDate={filters.DateFrom}
                endDate={filters.DateTo}
                setStartDate={date => {
                  setFilters(prevFilters => ({
                    ...prevFilters,
                    DateFrom: date,
                  }));
                }}
                setEndDate={date => {
                  setFilters(prevFilters => ({
                    ...prevFilters,
                    DateTo: date,
                  }));
                }}
                chipLabel={"Creation Date"}
              />
              {filters.firstName?.length > 0 &&
                (filtersIndex <= filtersLimit ||
                  (filtersIndex > filtersLimit && showFilters)) && (
                  <ChipItem
                    chipLabel='First Name'
                    chipValue={filters.firstName}
                    onDelete={() => {
                      setFilters(prevFilters => ({
                        ...prevFilters,
                        firstName: "",
                      }));
                    }}
                  />
                )}
              {filters.lastName?.length > 0 &&
                (filtersIndex <= filtersLimit ||
                  (filtersIndex > filtersLimit && showFilters)) && (
                  <ChipItem
                    chipLabel='Last Name'
                    chipValue={filters.lastName}
                    onDelete={() => {
                      setFilters(prevFilters => ({
                        ...prevFilters,
                        lastName: "",
                      }));
                    }}
                  />
                )}
              {/* {filters.email?.length > 0 &&
                (filtersIndex <= filtersLimit ||
                  (filtersIndex > filtersLimit && showFilters)) && (
                  <ChipItem
                    chipLabel='Email'
                    chipValue={filters.email}
                    onDelete={() => {
                      setFilters(prevFilters => ({
                        ...prevFilters,
                        email: "",
                      }));
                    }}
                  />
                )} */}

              {filters.email?.map(email => {
                // filtersIndex = filtersIndex + 1;
                return (
                  (filtersIndex <= filtersLimit ||
                    (filtersIndex > filtersLimit && showFilters)) && (
                    <ChipItem
                      chipLabel='Email'
                      chipValue={email}
                      onDelete={() =>
                        setFilters(prevFilters => ({
                          ...prevFilters,
                          email: prevFilters.email.filter(e => e !== email),
                        }))
                      }
                    />
                  )
                );
              })}

              {/* {filters.platform?.length > 0 &&
                (filtersIndex <= filtersLimit ||
                  (filtersIndex > filtersLimit && showFilters)) && (
                  <ChipItem
                    chipLabel='Platfrom'
                    chipValue={filters.platform}
                    onDelete={() => {
                      setFilters(prevFilters => ({
                        ...prevFilters,
                        platform: "",
                      }));
                    }}
                  />
                )} */}

              <SelectedChiptItems
                selectedItems={filters.platform}
                items={platformOptions}
                setFilters={setFilters}
                filtersIndex={filtersIndex}
                filtersLimit={filtersLimit}
                showFilters={showFilters}
                field={"platform"}
                chipLabel={"Platform"}
              />

              {filters.isConnected?.length > 0 &&
                (filtersIndex <= filtersLimit ||
                  (filtersIndex > filtersLimit && showFilters)) && (
                  <ChipItem
                    chipLabel='Contacted'
                    chipValue={filters.isConnected}
                    onDelete={() => {
                      setFilters(prevFilters => ({
                        ...prevFilters,
                        isConnected: null,
                      }));
                    }}
                  />
                )}

              <div
                style={{
                  textAlign: "right",
                }}>
                {filtersCount > filtersLimit && (
                  <IconButton
                    color={"primary"}
                    onClick={() => setShowFilter(!showFilters)}>
                    <MoreHoriz />
                  </IconButton>
                )}
              </div>
            </Accordion>
            <div className='userDetailsSearchField inputWrapper filterSelect'>
              <div style={{ marginBottom: "10px" }}>
                <h4>Product Creation Date</h4>
                <FilterCreationDate
                  StartDate={filters.DateFrom}
                  setStartDate={date => {
                    setFilters(prevFilters => ({
                      ...prevFilters,
                      DateFrom: date,
                    }));
                  }}
                  EndDate={filters.DateTo}
                  setEndDate={date => {
                    setFilters(prevFilters => ({
                      ...prevFilters,
                      DateTo: date,
                    }));
                  }}
                />
              </div>
              <InputField
                id='FirstName'
                name='FirstName'
                placeholder={"First Name"}
                value={filters.firstName}
                onChange={({ target }) =>
                  setFilters(prevFilters => ({
                    ...prevFilters,
                    firstName: target.value,
                  }))
                }
              />
              <InputField
                id='LastName'
                name='LastName'
                placeholder={"Last Name"}
                value={filters.lastName}
                onChange={({ target }) =>
                  setFilters(prevFilters => ({
                    ...prevFilters,
                    lastName: target.value,
                  }))
                }
              />
              <InputField
                id='Email'
                name='Email'
                placeholder={"Email"}
                value={emailValue}
                onChange={({ target }) => setEmailValue(target.value)}
                onKeyDown={({ key }) => {
                  if (key === "Enter") {
                    setFilters(prevFilters => ({
                      ...prevFilters,
                      email: [...prevFilters.email, emailValue],
                    }));
                    setEmailValue("");
                  }
                }}
              />
              <FilterAutoComplete
                value={platformOptions?.filter(eg =>
                  filters?.platform?.includes(eg.id)
                )}
                onChange={(event, value) => {
                  setFilters(prevFilters => ({
                    ...prevFilters,
                    platform: value.map(v => v.id),
                  }));
                }}
                id='Platform'
                options={platformOptions}
                getOptionLabel={option => option?.value || ""}
                placeholder={"Platform"}
                selectedFilter={filters.platform?.length}
              />
              <AutoComplete
                value={
                  connectionOptions.filter(x =>
                    filters?.isConnected?.includes(x.name)
                  )?.id ?? null
                }
                onChange={(event, value) => {
                  setFilters(prevFilters => ({
                    ...prevFilters,
                    isConnected: value.name,
                  }));
                }}
                id='leads-filters'
                options={connectionOptions}
                getOptionLabel={option => option?.name || ""}
                placeholder={"Is Contacted"}
              />
            </div>
          </GridSearchFilter>
          <LeadGenerationGrid
            onOrderBy={onOrderBy}
            order={order}
            LeadsData={LeadsData}
            roomMsgs={roomMsgs}
            setRoomMsgs={setRoomMsgs}
            selectedRoom={selectedRoom}
            setSelectedRoom={setSelectedRoom}
            leadData={leadData}
            setLeadData={setLeadData}
            onSendMessage={onSendMessage}
            isLoading={isLoading}
            setLoading={setLoading}
            onClearButtonPress={onClearButtonPress}
            handleExport={handleExport}
          />

          <Pagination
            recordCount={paginationResponse?.totalRecords}
            page={page - 1}
            setPage={setPage}
            rowsPerPage={rowsPerPage}
            setRowsPerPage={setRowsPerPage}
          />
        </div>
      </div>
    </Dashbard>
  );
};

export default LeadGeneration;
